export const INSERTION_ORDER_FULL_URL = 'insertion-order/full';

export const INSERTION_ORDER_BULK_URL = 'insertion-order/bulk';

export const LINE_ITEM_BULK_URL = 'line-item/bulk';

export const UPDATE_STATUS_URL = 'insertion-order/status/list';

export const REFRESH_METADATA_URL = 'refresh-metadata';
